/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions
 */
export interface FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions
     */
    AppId: string;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions(value: object): value is FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions {
    if (!('AppId' in value) || value['AppId'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'AppId': json['AppId'],
    };
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AppId': value['AppId'],
    };
}

